export default __webpack_public_path__ + "static/anuPrasad5-79e02cbd66eca09aff88dda6f0c7f3a1.jpg";